<template>
  <div class="container py-10 mx-auto px-1 sm:px-0">

    <!-- NEW: TCGPlayer Storefront Reviews -->
    <div class="mb-6 text-center">
      <h2 class="text-2xl font-bold underline underline-offset-4">
        <a 
          href="https://shop.tcgplayer.com/sellerfeedback/467df306" 
          target="_blank" 
          rel="noopener noreferrer" 
          class="hover:text-blue-600 transition"
        >
          TCGPlayer Storefront Reviews
        </a>
      </h2>
    </div>

    <p class="mt-3">
      <!-- Put your homepage text here -->
      The search tool is currently under development.  Do NOT enter any personal information in any of the accessible fields.
    </p>

    <div class="mt-6 flex justify-center">
      <img src="/assets/img/logo.png" alt="Perfect Storm Logo" class="max-w-md h-auto">
    </div>

    <!-- ======================== HERO / INTRO ======================== -->
    <section class="mt-10 space-y-4"> <!-- NEW -->
      <h1 class="text-3xl sm:text-4xl font-extrabold leading-tight"> <!-- NEW -->
        No one makes it easier – and faster – to sell your cards! <!-- NEW -->
      </h1> <!-- NEW -->

      <ol class="list-decimal pl-6 space-y-1 text-gray-800"> <!-- NEW -->
        <li>Ship us your Magic cards (easy instructions below).</li> <!-- NEW -->
        <li>We scan and price out each card.</li> <!-- NEW -->
        <li>You're paid – minus the fee.</li> <!-- NEW -->
      </ol> <!-- NEW -->
    </section> <!-- NEW -->

    <!-- ======================== VALUE PROPS ======================== -->
    <section class="mt-12 space-y-8 text-gray-900"> <!-- NEW -->
      <div> <!-- NEW -->
        <h2 class="font-semibold text-xl">Gather the Storm — You Pack, We Handle the Rest</h2> <!-- NEW -->
        <p class="mt-1">Send in your Magic cards. We handle the rest!</p> <!-- NEW -->
        <p class="italic text-gray-700">
          <router-link class="text-blue-600 underline" to="/how-to-pack-ship">How to ship cards</router-link>
        </p> <!-- NEW -->
      </div> <!-- NEW -->

      <div> <!-- NEW -->
        <h2 class="font-semibold text-xl">Forecast Always Current — Competitive Buylist Prices</h2> <!-- NEW -->
        <p class="mt-1">
          Our buy prices move with the market and update in real time so you get the best pricing for your cards!
        </p> <!-- NEW -->
        <p class="italic text-gray-700">
          <router-link class="text-blue-600 underline" to="/search">Price checking tool</router-link>
        </p> <!-- NEW -->
      </div> <!-- NEW -->

      <div> <!-- NEW -->
        <h2 class="font-semibold text-xl">Lightning Strike Speed — Fast Processing</h2> <!-- NEW -->
        <p class="mt-1">
          Your report will be ready in 2–4 business days, depending on service type.
        </p> <!-- NEW -->
        <p class="italic text-gray-700">
          <router-link class="text-blue-600 underline" to="/faqs">FAQ Page</router-link>
        </p> <!-- NEW -->
      </div> <!-- NEW -->

      <div> <!-- NEW -->
        <h2 class="font-semibold text-xl">Trust in the Eye of the Storm</h2> <!-- NEW -->
        <p class="mt-1">
          We’ve been putting customers first for decades — and will be for decades more!
        </p> <!-- NEW -->
        <p class="italic text-gray-700">
          (Placeholder for hotlink to reviews)
        </p> <!-- NEW -->
      </div> <!-- NEW -->
    </section> <!-- NEW -->

    <!-- ======================== OUR SERVICES ======================== -->
    <section class="mt-12 space-y-6"> <!-- NEW -->
      <h2 class="text-2xl font-bold">Our Services</h2> <!-- NEW -->

      <p>
        We have three tiers of service for selling your cards. The more focused your list — the lower the fees —
        but you can send in an unsorted lot as well and we’ll take care of it — lightning fast!
      </p> <!-- NEW -->

      <!-- Standard -->
      <div class="space-y-1"> <!-- NEW -->
        <h3 class="font-semibold text-lg">Standard Service → “Wild Storm”</h3> <!-- NEW -->
        <p class="italic text-gray-700">
          Anything goes, chaotic and untamed — higher fees because we do all the sorting.
        </p> <!-- NEW -->
        <p>Fees are 10% of total value, plus $0.03 per card.</p> <!-- NEW -->
        <p>Send us up to 3,200 cards of any value.</p> <!-- NEW -->
      </div> <!-- NEW -->

      <!-- Curated -->
      <div class="space-y-1"> <!-- NEW -->
        <h3 class="font-semibold text-lg">Curated Service → “Focused Storm”</h3> <!-- NEW -->
        <p class="italic text-gray-700">
          A narrower channeling of power — only the stronger spells (valuable cards) get cast.
        </p> <!-- NEW -->
        <p>Fees are 5% of total value, no per-card fee!</p> <!-- NEW -->
        <p>
          Send us up to 3,200 cards worth $0.50 or more ►
          <router-link class="text-blue-600 underline" to="/search">Price Lookup Tool</router-link>.
        </p> <!-- NEW -->
      </div> <!-- NEW -->

      <!-- Fully-Sorted -->
      <div class="space-y-1"> <!-- NEW -->
        <h3 class="font-semibold text-lg">Fully-Sorted Service → “Perfect Storm”</h3> <!-- NEW -->
        <p class="italic text-gray-700">
          Carefully prepared and fully unleashed — maximum efficiency, lowest fees.
        </p> <!-- NEW -->
        <p>Fees are 2% of total value, no per-card fee!</p> <!-- NEW -->
        <p>
          Send us up to 3,200 cards of any price with ►
          <router-link class="text-blue-600 underline" to="/search">Price Lookup Tool</router-link>,
          and sort them ahead of time in the order we provide for you.
        </p> <!-- NEW -->
      </div> <!-- NEW -->

      <!-- Regardless list -->
      <div class="mt-6"> <!-- NEW -->
        <p class="font-medium">Regardless of which option you choose:</p> <!-- NEW -->
        <ul class="list-disc pl-6 space-y-2 text-gray-800"> <!-- NEW -->
          <li>You’ll get a full reporting of the cards we process.</li> <!-- NEW -->
          <li>
            Choose your service when (link) ►
            <router-link to="/collection-estimate" class="text-blue-600 underline">Registering a shipment (Haha look at me!  Tell me where I'm supposed to hotlink you to!)</router-link>.
          </li> <!-- NEW -->
          <li>Multiple payment options: ACH, PayPal, Venmo, and In-Store Credit (20% bonus!).</li> <!-- NEW -->
          <li>
            Check out our
            <router-link to="/faqs" class="text-blue-600 underline">FAQ</router-link>
            for more details.
          </li> <!-- NEW -->
        </ul> <!-- NEW -->
      </div> <!-- NEW -->
    </section> <!-- NEW -->

    <!-- ======================== BEST PRICES SECTION ======================== -->
    <section class="mt-12 space-y-4"> <!-- NEW -->
      <h2 class="text-2xl font-bold">How we get you the best prices for your cards</h2> <!-- NEW -->
      <div class="space-y-4"> <!-- NEW -->
        <p>
          <span class="font-semibold">Channeling Demand</span> — With multiple retail locations, a strong player community,
          and an Enterprise-Level TCGPlayer store we move cards faster, which means we can pay you more up front!
        </p> <!-- NEW -->
        <p>
          <span class="font-semibold">Price-checking tool is up-to-the-minute accurate</span> —
          Pricing on our price checker updates in real time so you have the best buy price available!
          (link) ►
          <router-link class="text-blue-600 underline" to="/search">Price Checking Tool</router-link>,
          <router-link class="text-blue-600 underline" to="/collection-estimate">Collection Estimate Upload</router-link>
        </p> <!-- NEW -->
        <p>
          <span class="font-semibold">Clear Skies — no hidden fees</span> — What you see is what you get. No extra cuts,
          no sneaky percentages shaved off your payout.
        </p> <!-- NEW -->
        <p>
          <span class="font-semibold">Direct Lightning Strikes</span> — We connect your cards directly to the players who
          want them most—no wholesalers, no delays, just value.
        </p> <!-- NEW -->
      </div> <!-- NEW -->
    </section> <!-- NEW -->

    <!-- ======================== STORM REPORT SECTION ======================== -->
    <section class="mt-12 space-y-4"> <!-- NEW -->
      <h2 class="text-2xl font-bold">Storm Report — transparent &amp; accurate</h2> <!-- NEW -->
      <p>
        Every collection we process gets a <span class="font-semibold">Storm Report</span> — your personal snapshot of value.
      </p> <!-- NEW -->
      <ul class="list-disc pl-6 space-y-2 text-gray-800"> <!-- NEW -->
        <li><span class="font-semibold">Real-Time Accuracy</span> — Prices reflect the market at the moment your collection is reviewed.</li> <!-- NEW -->
        <li><span class="font-semibold">Full Visibility</span> — Every card counted, graded, and valued; nothing hidden in the clouds.</li> <!-- NEW -->
        <li><span class="font-semibold">Detailed Breakdown</span> — See bulk, rares, foils, and high-value cards separated and priced.</li> <!-- NEW -->
        <li><span class="font-semibold">Clear Forecast</span> — Understand exactly how your total value is calculated — buylist pricing, fees, and everything — in one easy-to-read report.</li> <!-- NEW -->
        <li><span class="font-semibold">Stormproof Confidence</span> — With our report, you know your payout is fair, accurate, and fully transparent.</li> <!-- NEW -->
      </ul> <!-- NEW -->
    </section> <!-- NEW -->

    <!-- ======================== CTA ======================== -->
    <section class="mt-12 space-y-6 text-center"> <!-- NEW -->
      <p class="italic text-gray-600">
        (Reviews here)
      </p> <!-- NEW -->

      <div class="space-y-3"> <!-- NEW -->
        <p class="text-lg">Ready to roll up your sleeves?</p> <!-- NEW -->
        <p>Do a little pre-sorting and pay only 5% fees with our “Focused Storm” Service (link to “register a shipment”)</p> <!-- NEW -->
        <p>Send a shipment of only valuable cards ($0.50+ buylist), and we’ll take it from there.</p> <!-- NEW -->
        <p>Let us make it easy for you to get paid!</p> <!-- NEW -->
      </div> <!-- NEW -->

      <p class="mt-6"> <!-- NEW -->
        <span class="font-semibold">Ready to get started?</span><br />
        <a href="/register" class="text-blue-600 underline">Register here</a>
      </p> <!-- NEW -->
    </section> <!-- NEW -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const sets = ref([]);
const gamesWithoutSets = ref([]);
const gamesWithSets = ref([]);
const cards = ref([]);

async function fetchCards() {
  const url = '/api/v1/cards';
  try {
    const res = await fetch(url);
    const json = await res.json();
    cards.value = json.data;
  } catch (e) {
    console.error('Failed to fetch cards:', e);
  }
}

async function fetchSets() {
  const url = '/api/v1/sets';
  try {
    const res = await fetch(url);
  const json = await res.json();
    sets.value = json.data;
  } catch (e) {
    console.error('Failed to fetch sets:', e);
  }
}

async function fetchGames(withSets = false) {
  const url = withSets ? '/api/v1/games?with_sets=true' : '/api/v1/games';
  try {
    const res = await fetch(url);
    const json = await res.json();
    if (withSets) {
      gamesWithSets.value = json;
    } else {
      gamesWithoutSets.value = json;
    }
  } catch (e) {
    console.error('Failed to fetch games:', e);
  }
}
</script>